import * as types from '../types';
import { IRecurringJobsApi } from '../contracts';
import { HttpApi } from './HttpApi';

const BASE = '/recurring-jobs';

export class RecurringJobsHttpApi extends HttpApi implements IRecurringJobsApi {
  async listRecurringSchedules(
    page = 1,
    limit = 20,
    filters: types.RecurringScheduleListFilters = {}
  ): Promise<types.PaginatedResponse<types.RecurringSchedule>> {
    // Blank filters are left out so the server does not filter on ''.
    const params: Record<string, string | number> = { page, limit };
    (['status', 'customerId', 'propertyId'] as const).forEach((key) => {
      const value = filters[key];
      if (value) params[key] = value;
    });
    const response = await this.http.get<types.PaginatedResponse<types.RecurringSchedule>>(BASE, { params });
    return response.data;
  }

  async getRecurringSchedule(id: string): Promise<types.RecurringScheduleDetail> {
    const response = await this.http.get<types.APIResponse<types.RecurringScheduleDetail>>(`${BASE}/${id}`);
    return response.data.data;
  }

  async createRecurringSchedule(data: types.CreateRecurringScheduleRequest): Promise<types.RecurringSchedule> {
    const response = await this.http.post<types.APIResponse<types.RecurringSchedule>>(BASE, data);
    return response.data.data;
  }

  async updateRecurringSchedule(id: string, data: types.UpdateRecurringScheduleRequest): Promise<types.RecurringSchedule> {
    const response = await this.http.patch<types.APIResponse<types.RecurringSchedule>>(`${BASE}/${id}`, data);
    return response.data.data;
  }

  async deleteRecurringSchedule(id: string): Promise<void> {
    await this.http.delete(`${BASE}/${id}`);
  }

  async generateRecurringJobs(id: string): Promise<types.RecurringGenerationResult> {
    const response = await this.http.post<types.APIResponse<types.RecurringGenerationResult>>(`${BASE}/${id}/generate`);
    return response.data.data;
  }

  async previewRecurringOccurrences(id: string, limit?: number): Promise<types.RecurringPreview> {
    const response = await this.http.get<types.APIResponse<types.RecurringPreview>>(`${BASE}/${id}/preview`, {
      params: limit ? { limit } : {},
    });
    return response.data.data;
  }

  async addRecurringSkippedDate(id: string, date: string): Promise<types.RecurringSchedule> {
    const response = await this.http.post<types.APIResponse<types.RecurringSchedule>>(
      `${BASE}/${id}/skip-dates/${encodeURIComponent(date)}`
    );
    return response.data.data;
  }

  async removeRecurringSkippedDate(id: string, date: string): Promise<types.RecurringSchedule> {
    const response = await this.http.delete<types.APIResponse<types.RecurringSchedule>>(
      `${BASE}/${id}/skip-dates/${encodeURIComponent(date)}`
    );
    return response.data.data;
  }
}
